import api from "./api";

export const authService = {
  ssdiLogin: async (payload) => {
    const res = await api.post("/auth/ssdi-login", payload);
    return res.data?.data;
  },

  repoAdminLogin: async (payload) => {
    const res = await api.post("/repo-admin/login", payload);
    return res.data?.data;
  },

  repoAgentLogin: async (payload) => {
    const res = await api.post("/auth/repo-agent-login", payload);
    return res.data?.data;
  },

  getEffectivePermissions: async (token) => {
    const res = await api.get("/agency-roles/me", {
      headers: { Authorization: `Bearer ${token}` },
    });

    return res.data?.data || res.data || { permissions: [] };
  },

  agentSelfRegister: async (payload) => {
    const res = await api.post("/auth/agent-register", payload);
    return res.data;
  },

  resendAgentRegistrationOtp: async (registrationId) => {
    const res = await api.post(
      "/auth/agent-register/resend-otp",
      {
        registrationId,
      }
    );

    return res.data;
  },

  verifyAgentRegistration: async (
    registrationId,
    otp
  ) => {
    const res = await api.post(
      "/auth/agent-register/verify-otp",
      {
        registrationId,
        otp,
      }
    );

    return res.data;
  },

  /*
   * ==========================================
   * Forgot Password
   * ==========================================
   */

  // Find all active accounts registered
  // with the supplied mobile number.
  findForgotPasswordAccounts: async (payload) => {
    const res = await api.post(
      "/auth/forgot-password/accounts",
      payload
    );

    return res.data;
  },

  // Send OTP for the selected account.
  sendForgotPasswordOtp: async (payload) => {
    const res = await api.post(
      "/auth/forgot-password/send-otp",
      payload
    );

    return res.data;
  },

  // Verify OTP for the selected account.
  verifyForgotPasswordOtp: async (payload) => {
    const res = await api.post(
      "/auth/forgot-password/verify-otp",
      payload
    );

    return res.data;
  },

  // Reset password using the reset token.
  resetPasswordWithOtp: async (payload) => {
    const res = await api.post(
      "/auth/forgot-password/reset",
      payload
    );

    return res.data;
  },

  /*
   * ==========================================
   * Session
   * ==========================================
   */

  refreshSession: async (token) => {
    const res = await api.post(
      "/auth/refresh",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        skipAuthExpire: true,
      }
    );

    return res.data?.data;
  },

  /*
   * ==========================================
   * Profile
   * ==========================================
   */

  getProfile: async (token) => {
    const res = await api.get("/auth/profile", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res.data;
  },

  updateProfile: async (payload, token) => {
    const res = await api.patch(
      "/auth/profile",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res.data;
  },

  uploadProfilePhoto: async (file, token) => {
    const formData = new FormData();

    formData.append("photo", file);

    const res = await api.post(
      "/auth/profile/photo",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data;
  },

  getIdCardData: async (token) => {
    const res = await api.get(
      "/auth/id-card-data",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res.data;
  },
};